import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {baseUrl, userLocation} from '../Univ.js'
function PharmInvoiceIndent(props) {
    const {sale_pharm} = useParams();
    const [opbillData, setopbillData] = useState([]);
    const [hospData, setHospData] = useState([]);
    const [viewPharmData, setViewPharmData] = useState([]);
    useEffect(() => {
        try {
            axios.get(baseUrl + 'pharm-invoice-other/' + sale_pharm)
                .then(function (response) {
                    setopbillData(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
            });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        if (opbillData.length > 0) {
            fetchPharmData();
        }
    }, [opbillData]);
    function fetchPharmData() {
        const ipIds = opbillData.map(row => row.product.split(',').map(item => item.trim()));
        ipIds.forEach(ipId => {
            try {
                ipId.forEach(id => {
                    axios.get(baseUrl + 'update-pharm-qty/' + id + '/')
                        .then(function (response) {
                            const data = Object.assign({}, response.data);
                            setViewPharmData(prevData => [...prevData, data]);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                });
            } catch (error) {
                console.log(error);
            }
        });
    }
    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };
    function numberToWords(num) {
        const units = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        const scales = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion', 'decillion', 'undecillion', 'duodecillion', 'tredecillion', 'quattuordecillion', 'quindecillion', 'sexdecillion', 'septendecillion', 'octodecillion', 'novemdecillion', 'vigintillion'];
        function convertThreeDigitsLessThanThousand(num) {
            if (num === 0) return '';
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            const onesDigit = num % 10;
            const tensDigit = Math.floor((num % 100) / 10);
            const hundredsDigit = Math.floor(num / 100);
            let result = '';
            if (hundredsDigit > 0) {
                result = `${units[hundredsDigit]} hundred`;
            }
            if (tensDigit > 0) {
                if (result) result += ' and ';
                if (tensDigit === 1) {
                    result += teens[onesDigit];
                } else if (onesDigit === 0) {
                    result += tens[tensDigit];
                } else {
                    result += `${tens[tensDigit]}-${units[onesDigit]}`;
                }
            } else if (onesDigit > 0) {
                if (result) result += ' and ';
                result += units[onesDigit];
            }
            return result;
        }
        function convertThreeDigits(num) {
            if (num === 0) return 'zero';
            if (num < 1000) return convertThreeDigitsLessThanThousand(num);
            let words = '';
            let scaleIndex = 0;
            while (num > 0) {
                const currentNum = num % 1000;
                if (currentNum !== 0) {
                    const currentWords = convertThreeDigitsLessThanThousand(currentNum);
                    if (scaleIndex > 0) {
                        words = `${currentWords} ${scales[scaleIndex]} ${words}`;
                    } else {
                        words = `${currentWords} ${words}`;
                    }
                }
                scaleIndex++;
                num = Math.floor(num / 1000);
            }
            return words.trim();
        }
        if (num === 10000) {
            return 'ten thousand rupees only';
        }
        if (num === 0) {
            return 'zero rupees only';
        }
        if (num < 0) return `negative ${numberToWords(Math.abs(num))}`;
        const parts = num.toString().split('.');
        let integerPart = parseInt(parts[0], 10);
        let decimalPart = parseInt(parts[1], 10) || 0;
        let words = '';
        let scaleIndex = 0;
        // Convert integer part
        while (integerPart > 0) {
            const hundreds = integerPart % 1000;
            if (hundreds !== 0) {
                const hundredsWords = convertThreeDigits(hundreds);
                if (scaleIndex !== 0) {
                    words = `${hundredsWords} ${scales[scaleIndex]} ${words}`;
                } else {
                    words = `${hundredsWords} ${words}`;
                }
            }
            scaleIndex++;
            integerPart = Math.floor(integerPart / 1000);
        }
        // Convert decimal part
        if (decimalPart > 0) {
            words += ' and ';
            if (decimalPart < 10) {
                words += units[decimalPart];
            } else if (decimalPart < 20) {
                words += teens[decimalPart - 11];
            } else {
                const onesDigit = decimalPart % 10;
                const tensDigit = Math.floor(decimalPart / 10);
                if (onesDigit === 0) {
                    words += tens[tensDigit];
                } else {
                    words += `${tens[tensDigit]}-${units[onesDigit]}`;
                }
            }
            words += ' paisa';
        }
        words += ' rupees only';
        return words.trim();
    }
    return (
        <section>
            <div>
                {opbillData.map((row, index) =>
                    <div id="invoice-print">
                        <div className="table-responsive">
                            <table
                                rules="rows"
                                cellPadding="1"
                                className="text-justify mt-1 hospital-responsive-table"
                                width="100%"
                            >
                                <thead>
                                <tr>
                                    {hospData.map((hospital) => (
                                        <React.Fragment key={hospital.id}>
                                            <td align="right" colSpan="2" style={{
                                                borderBottom: '1px solid black', borderTop: '1px solid black',
                                                padding: '4px', borderRadius: '25px', color: '#000'
                                            }}>
                                                <p align="center">
                                                    <img
                                                        src={hospital.logo}
                                                        alt="Hospital Logo"
                                                        style={{width: "60px", height: "60px", objectFit: "contain"}}
                                                    />
                                                    <strong>{hospital.hospital}</strong><br/>
                                                    Address&nbsp;: &nbsp;{hospital.address}&nbsp;&nbsp;&nbsp;-&nbsp;
                                                    <br/>Phone : {hospital.mobile} &nbsp; Email
                                                    : {hospital.email} &nbsp; <br/>
                                                    Web : {hospital.website}
                                                </p>
                                            </td>
                                        </React.Fragment>
                                    ))}
                                </tr>
                                </thead>
                                <tr>
                                    <th className="mx-0 ps-5" rowSpan="10">
                                        <font>Department : {row.patient} </font><br></br>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="mx-5 ps-5">
                                        <font>Invoice No #:&nbsp;{row.sale_id}</font><br></br>
                                        <font>Date :&nbsp;{row.add_date}</font><br></br>
                                        <font>{row.mode.charAt(0).toUpperCase() + row.mode.slice(1)} Receipt</font>
                                    </th>
                                </tr>
                            </table>
                            <div>

                                <table border="2" rules="rows" cellpadding="3" className="text-justify mt-4"
                                       width="100%">
                                    <thead>
                                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                        <th align="left">S.No</th>
                                        <th align="left">Product</th>
                                        <th align="left">Batch No</th>
                                        <th align="left">Expiry Date</th>
                                        <th align="left">Packs</th>
                                        <th align="left">MRP</th>
                                        <th align="left">Qty</th>
                                        <th align="left">Net Amount</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {row.product.split(',').map((test, subIndex) => {
                                        const pharmData = viewPharmData.find((data) => data.id == test);
                                        return (
                                            <tr key={`${index}-${subIndex}`}
                                                style={{border: "1px solid", borderColor: "#2194d9"}}>
                                                <td>{index + subIndex + 1}</td>
                                                <td>{pharmData?.product}</td>
                                                <td>{pharmData?.batch}</td>
                                                <td>{pharmData?.expiry}</td>
                                                <td>{pharmData?.pack}</td>
                                                <td><i className="fa fa-inr"
                                                       aria-hidden="true"></i>&nbsp;{pharmData?.mrp}</td>
                                                <td><b>{row.qty.split(',')[subIndex].trim()}</b></td>
                                                <td><b><i className="fa fa-inr"
                                                          aria-hidden="true"></i>&nbsp;{row.netamount.split(',')[subIndex].trim()}
                                                </b></td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td align="center" colSpan="6"></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Invoiced
                                            Amount</b></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            <b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.total}</b>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p className="mt-2 p-3 text-bold">Received the sum
                                of {numberToWords(parseFloat(row.total))}.</p>
                            <div style={{display: 'flex', justifyContent: 'right', alignItems: 'right'}}>
                                <tr>
                                    <th>{row.addedby}</th>
                                    <br></br>
                                    <th style={{width: "200px", borderTop: "2px solid black"}}>Cashier</th>
                                </tr>
                            </div>
                        </div>
                    </div>
                )}
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button
                        style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                </div>
            </div>
        </section>
    );
}
export default PharmInvoiceIndent;